// Importing registers the `<app-svelte>` custom element as a side effect
// (rollup.config.js compiles every component with customElement: true).
import './App.svelte';

const app = document.createElement('app-svelte');
document.body.appendChild(app);

export default app;